export const LOAD_FOLDER_HEADER_STARTED = "LOAD_FOLDER_HEADER_STARTED";
export const LOAD_FOLDER_HEADER_SUCCESS = "LOAD_FOLDER_HEADER_SUCCESS";
export const LOAD_FOLDER_WARNINGS_SUCCESS = "LOAD_FOLDER_WARNINGS_SUCCESS";
export const RESET_CURRENT_FOLDER = "RESET_CURRENT_FOLDER";
export const LOAD_FOLDER_PARTNER_SUCCESS = "LOAD_FOLDER_PARTNER_SUCCESS";
export const LOAD_FOLDER_GENERAL_INFO_STARTED = "LOAD_FOLDER_GENERAL_INFO_STARTED";
export const LOAD_FOLDER_GENERAL_INFO_SUCCESS = "LOAD_FOLDER_GENERAL_INFO_SUCCESS";
export const LOAD_FOLDER_REPORTS_SUCCESS = "LOAD_FOLDER_REPORTS_SUCCESS";
